module.exports = __webpack_public_path__ + "static/media/S3N5-2.cf525d83.svg";